
import {
  Vue,
  Component,
  Prop,
  ModelSync,
  Inject
} from "vue-property-decorator";
import { Control, OxygenControlsTreeContext } from "@/oxygen/classes/lib/types";
import OxygenGapInput from "@/oxygen/classes/inputs/OxygenGapInput.vue";
import OxygenFontFamilyInput from "@/oxygen/classes/inputs/OxygenFontFamilyInput.vue";
import OxygenUnitInput from "@/oxygen/classes/inputs/OxygenUnitInput.vue";
import OxygenGroupInput from "@/oxygen/classes/inputs/OxygenGroupInput.vue";
import OxygenColorInput from "@/oxygen/classes/inputs/OxygenColorInput.vue";
import OxygenSelectInput from "@/oxygen/classes/inputs/OxygenSelectInput.vue";
import OxygenSpacingInput from "@/oxygen/classes/inputs/spacing/OxygenSpacingInput.vue";
import OxygenButtonBarInput from "@/oxygen/classes/inputs/OxygenButtonBarInput.vue";
import OxygenAccordionInput from "@/oxygen/classes/inputs/OxygenAccordionInput.vue";
import OxygenNumberInput from "@/oxygen/classes/inputs/OxygenNumberInput.vue";
import OxygenTextInput from "@/oxygen/classes/inputs/OxygenTextInput.vue";
import OxygenCodeInput from "@/oxygen/classes/inputs/OxygenCodeInput.vue";
import OxygenAlignInput from "@/oxygen/classes/inputs/align/OxygenAlignInput.vue";
import OxygenBorderInput from "@/oxygen/classes/inputs/OxygenBorderInput.vue";
import OxygenBorderRadiusInput from "@/oxygen/classes/inputs/OxygenBorderRadiusInput.vue";
import OxygenFocusPointInput from "@/oxygen/classes/inputs/OxygenFocusPointInput.vue";
import OxygenRepeaterInput from "@/oxygen/classes/inputs/repeater/OxygenRepeaterInput.vue";
import OxygenMediaInput from "@/oxygen/classes/inputs/OxygenMediaInput.vue";
import OxygenVideoInput from "@/oxygen/classes/inputs/OxygenVideoInput.vue";
import VariableBoundInput from "@/oxygen/variables/VariableBoundInput.vue";
import { doesControlHaveValueSetOrDoesControlSectionHaveDescendantsWithValue } from "@/lib/controls/values";
import OxygenMediaSizeInput from "@/oxygen/classes/inputs/OxygenMediaSizeInput.vue";
import OxygenButtonInput from "@/oxygen/classes/inputs/OxygenButtonInput.vue";
import { showControl } from "@/oxygen/classes/lib/conditions";
import {
  controlTypeToVariableType,
  doesControlAcceptVariable
} from "@/oxygen/variables/lib/utils";
import OxygenVariablesInput from "@/oxygen/classes/inputs/OxygenVariablesInput.vue";
import { uiStore } from "@/store/store";
import OxygenControlName from "@/oxygen/classes/OxygenControlName.vue";

@Component({
  components: {
    OxygenControlName,
    OxygenVariablesInput,
    OxygenGapInput,
    OxygenTextInput,
    OxygenUnitInput,
    OxygenCodeInput,
    OxygenGroupInput,
    OxygenAlignInput,
    OxygenColorInput,
    OxygenMediaInput,
    OxygenVideoInput,
    OxygenSelectInput,
    OxygenNumberInput,
    OxygenBorderInput,
    OxygenButtonInput,
    OxygenSpacingInput,
    OxygenRepeaterInput,
    OxygenButtonBarInput,
    OxygenAccordionInput,
    OxygenFocusPointInput,
    OxygenFontFamilyInput,
    OxygenBorderRadiusInput,
    OxygenMediaSizeInput,
    VariableBoundInput
  }
})
export default class OxygenControl extends Vue {
  @Prop()
  control!: Control;

  @ModelSync("value", "input")
  syncedValue?: unknown;

  @Prop()
  path?: string;

  @Inject({ from: "oxyContext" })
  readonly context!: OxygenControlsTreeContext;

  get showLabel() {
    if (this.control.hideLabel) return false;
    return !["accordion"].includes(this.control.type);
  }

  get filled() {
    return doesControlHaveValueSetOrDoesControlSectionHaveDescendantsWithValue(
      this.syncedValue
    );
  }

  get disabled() {
    if (!this.path) return false;
    if (!this.control.disabledConditions) return false;

    const values = this.context.getParentControlValueAt(
      "", // Relative to root
      uiStore.currentBreakpoint.id
    );

    return showControl(this.control.disabledConditions, values);
  }

  get isVariableSupported() {
    return doesControlAcceptVariable(this.control);
  }

  get componentName() {
    return `oxygen-${this.control.type}-input`;
  }

  get variableType() {
    return controlTypeToVariableType(this.control);
  }

  get fullPath() {
    if (!this.path) return this.control.slug;
    return `${this.path}.${this.control.slug}`;
  }

  resetControl() {
    this.syncedValue = undefined;
  }
}
